import { useSubsequentEffect } from '@carvana/merch-react-hooks';
import { useContext, useRef } from 'react';
import SearchSource from '~/constants/SearchSource';
import { useTrackEvent } from '~/contexts/SearchAnalyticsContext';
import SearchEventsDataContext from '~/contexts/SearchEventsDataContext';
import { useUserLocation } from '~/contexts/UserContext';

export default function useLogZipCodeChanges() {
  const { setSearchSource } = useContext(SearchEventsDataContext);
  const { zip } = useUserLocation();
  const previousZip = useRef(zip);
  const trackEvent = useTrackEvent();

  useSubsequentEffect(() => {
    trackEvent('zip code changed', {
      previousZip: previousZip.current,
      newZip: zip
    });
    previousZip.current = zip;
  }, [trackEvent, zip]);

  useSubsequentEffect(() => {
    setSearchSource(SearchSource.Location);
  }, [zip, setSearchSource]);
}
